module.exports = __webpack_public_path__ + "static/media/TV-SCIS.36b9b1a2.png";